<div class="menu columns">
  <nav class="column-1-2 menu__site">
    <ul class="menu__site__list">
      <li class="menu__site__list-item" *ngFor="let item of menuItems; let i = index">
        <a *ngIf="item.url" (click)="clickItem()" [href]="item.url">{{ item.title }}</a>
        <a
          *ngIf="item.routerLink"
          (click)="clickItem()"
          [routerLinkActive]="'is--active'"
          [routerLinkActiveOptions]="{ exact: i == 0 ? true : false }"
          [routerLink]="item.routerLink"
        >
          {{ item.title }}
        </a>
      </li>
    </ul>
  </nav>

  <div class="column-1-2">
    <nav class="menu__app">
      <h1 class="h3 menu__app-title">Apps</h1>
      <ul class="menu__app__list">
        <li class="menu__app__list-item" (click)="clickItem()" *ngFor="let item of menuAppItems">
          <a [href]="item.url" target="_blank">
            <app-icon [anchor]="item.icon"></app-icon>
            {{ item.title }}
          </a>
        </li>
      </ul>
    </nav>
    <div class="menu__clocks">
      <app-clock class="clock-component" [location]="'Rotterdam'" [timezone]="'Europe/Amsterdam'"></app-clock>
      <app-clock class="clock-component" [location]="'Berlin'" [timezone]="'Europe/Berlin'"></app-clock>
      <app-clock class="clock-component" [location]="'Paris'" [timezone]="'Europe/Paris'"></app-clock>
      <app-clock class="clock-component" [location]="'New York'" [timezone]="'America/New_York'"></app-clock>
      <app-clock class="clock-component" [location]="'Shanghai'" [timezone]="'Asia/Shanghai'"></app-clock>
    </div>
  </div>
</div>
